import { axiosInstance, API_PREFIX, type ApiResponse, type RequestParams } from '@/shared/api';
import type { ApiResponseList } from '@/shared/api/types';
import type {
  RoleBase,
  RoleById,
  RoleCreatePayload,
  RoleUpdatePayload,
  PermissionsResponse,
  PermissionGroup,
  RoleItem,
  RoleItemListParams,
} from '../model/types';

export const getList = async (params?: RequestParams): Promise<ApiResponseList<RoleBase>> => {
  const { data } = await axiosInstance.get<ApiResponseList<RoleBase>>(`${API_PREFIX.ADMIN_V1}/role/index`, {
    params,
  });

  return data;
};

export const getById = async (id: number): Promise<ApiResponse<RoleById>> => {
  const { data } = await axiosInstance.get<ApiResponse<RoleById>>(`${API_PREFIX.ADMIN_V1}/role/show`, {
    params: { id },
  });

  return data;
};

export const getItemList = async (params?: RoleItemListParams): Promise<ApiResponse<RoleItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<RoleItem[]>>(`${API_PREFIX.ADMIN_V1}/role/item-list`, {
    params: params,
  });

  return data;
};

export const create = async (payload: RoleCreatePayload): Promise<ApiResponse<RoleById>> => {
  const { data } = await axiosInstance.post<ApiResponse<RoleById>>(`${API_PREFIX.ADMIN_V1}/role/create`, payload);

  return data;
};

export const update = async (payload: RoleUpdatePayload): Promise<ApiResponse<RoleById>> => {
  const { data } = await axiosInstance.post<ApiResponse<RoleById>>(`${API_PREFIX.ADMIN_V1}/role/update`, payload);

  return data;
};

export const remove = async (id: number): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(`${API_PREFIX.ADMIN_V1}/role/delete`, { id });

  return data;
};

export const getPermissions = async (): Promise<ApiResponse<PermissionsResponse>> => {
  const { data } = await axiosInstance.get<ApiResponse<PermissionsResponse | PermissionGroup[]>>(
    `${API_PREFIX.ADMIN_V1}/permission/index`
  );

  // Real API may return a flat PermissionGroup[] instead of Record<string, PermissionGroup[]>.
  // Normalize to the expected grouped shape so the UI always works correctly.
  if (Array.isArray(data.result)) {
    return {
      ...data,
      result: { all: data.result },
    } as ApiResponse<PermissionsResponse>;
  }

  return data as ApiResponse<PermissionsResponse>;
};
